import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import { useAppDispatch } from '@/Application/Hooks/Redux';
import { QUERY_PARAMS } from '@/constants';
import type { IAvailablePaymentMethodsResponse } from '@/modules/perseo-billing/interfaces';

import {
  billingQueryKeys,
  getAvailablePayments
} from '../services/api/billing';
import { setAvailablePayments } from '../store/slices/billing';

export function useGetAvailablePayments() {
  const dispath = useAppDispatch();
  const [searchParam] = useSearchParams();

  const device = searchParam.get(QUERY_PARAMS.DEVICE) || 'web';

  const queryResult = useQuery<IAvailablePaymentMethodsResponse>(
    billingQueryKeys.availablePayments,
    () => getAvailablePayments(device),
    {
      onSuccess(data) {
        dispath(setAvailablePayments(data));
      },
      retry: 2,
      retryDelay: 2500
    }
  );
  return queryResult;
}
